export const loginRequest = {
  scopes: [
    "User.Read",
    "User.Read.All"
  ]
  };
  